import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/shared/ui";
import { en } from "@/shared/i18n/en";

/** `?` opens the shortcut list (unless you are typing in a field). */
export function ShortcutsHelp() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const el = e.target;
      if (
        el instanceof HTMLElement &&
        (/^(INPUT|TEXTAREA|SELECT)$/.test(el.tagName) || el.isContentEditable)
      )
        return;
      if (e.key === "?" && !e.ctrlKey && !e.metaKey && !e.altKey) {
        e.preventDefault();
        setOpen(true);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>{t("shortcuts.title")}</DialogTitle>
        <DialogDescription>{t("shortcuts.hint")}</DialogDescription>
        <table className="mt-4 w-full text-sm">
          <tbody>
            {en.shortcuts.rows.map(([keys, what]) => (
              <tr key={keys} className="border-t border-border">
                <th scope="row" className="py-1.5 pr-4 text-left font-mono text-xs font-normal">
                  {keys}
                </th>
                <td className="py-1.5">{what}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
